<div class="login-shell default-theme" data-cy="iot-platform-login-shell">
  <div class="login-shell-row flex flex-row max-[959px]:flex-col">
    <div class="login-shell-col max-w-1/2 flex-[1_1_50%] max-[959px]:max-w-full max-[959px]:flex-[1_1_100%]"></div>
    <div class="login-shell-col flex max-w-1/2 flex-[1_1_50%] flex-col max-[959px]:max-w-full max-[959px]:flex-[1_1_100%]">
      <h1 class="login-shell-title fw-600">{{ authConfig()?.appName }}</h1>

      @if (!loggedIn() && !stepEmail() && !stepPassword() && !loginWithEmailPassword() && !requireNewPassword()) {
        <iot-platform-login-select-authentication
          data-cy="iot-platform-login-select-authentication"
          class="flex-1 content-center items-center"
          [ssoDisabled]="!!authConfig()?.ssoDisabled"
          (signInWithSSO)="onSignInWithSSO()"
          (signInWithEmailPassword)="onSignInWithEmailPassword()"
        />
      }

      @if (loginWithEmailPassword() && !requireNewPassword() && !stepEmail() && !stepPassword()) {
        <iot-platform-login-form
          data-cy="iot-platform-login-form"
          class="flex-1 content-center items-center"
          [ssoDisabled]="!!authConfig()?.ssoDisabled"
          [rememberMe]="!!authConfig()?.rememberMe"
          [isI4BLogin]="true"
          [hasError]="errorSignIn()"
          (cancel)="onCancel()"
          (resetPassword)="onResetPassword()"
          (signIn)="onSignIn($event)"
        />
      }

      @if (requireNewPassword()) {
        <iot-platform-login-change-temporary-password-form
          data-cy="iot-platform-login-change-temporary-password-form"
          class="flex-1 content-center items-center"
          [hasError]="errorPassword()"
          (cancel)="onCancel()"
          (changeTemporaryPassword)="onChangeTemporaryPassword($event)"
        />
      }

      @if (stepEmail()) {
        <iot-platform-login-send-code-form
          data-cy="iot-platform-login-send-code-form"
          class="flex-1 content-center items-center"
          [hasError]="errorEmail()"
          [isI4BLogin]="true"
          (cancel)="onCancel()"
          (sendCode)="onSendCode($event)"
        />
      }

      @if (stepPassword()) {
        <iot-platform-login-reset-password-form
          data-cy="iot-platform-login-reset-password-form"
          class="flex-1 content-center items-center"
          [username]="username()"
          [hasError]="errorPassword()"
          (cancel)="onCancel()"
          (sendCode)="onSendCode($event)"
          (changePassword)="onChangeForgottenPassword($event)"
        />
      }

      @if (loggedIn() && !requireNewPassword() && !stepPassword()) {
        <iot-platform-login-select-profile
          data-cy="iot-platform-login-select-profile"
          class="flex-1 content-center items-center"
          [businessProfiles]="businessProfiles()"
          [loading]="pending()"
          (selectProfile)="onSelectProfile($event)"
        />
      }
    </div>
  </div>
</div>
